export type FaqItem = {
    question: string
    answer: string
    link?: {
        label: string
        href: string
    }
}

export const FAQ: Array<FaqItem> = [
    {
        question: "Is the food halal?",
        answer: "Yes. The whole kitchen is halal, every day, and there is no pork anywhere on the menu."
    },
    {
        question: "Do you serve alcohol?",
        answer: "No. Our Sans Alcool bar composes its drinks with the same care as any cocktail list, and pairs each one with a dish.",
        link: { label: "Visit Sans Alcool", href: '/sans-alcool' }
    },
    {
        question: "Is there a vegetarian option?",
        answer: "Several. Look for the small brass dot on the menu. Most of the mezze are vegetarian, and the wood-fired cauliflower is a main course in its own right.",
        link: { label: "See the menu", href: '/menu' }
    },
    {
        question: "Can I bring children?",
        answer: "Please do. We have high chairs and smaller plates, and the kitchen is happy to keep things simple for younger guests."
    },
    {
        question: "Do you take walk-ins?",
        answer: "Yes. The counter is kept for walk-ins every evening. For a table at a set time, it is best to reserve."
    },
    {
        question: "Is there a dress code?",
        answer: "No. Come as you are. Most guests dress for an evening out, and no one will mind if you do not."
    }
]
